<template>
  <div>
    <button
      class="bbutton"
      @click="openModal"
    >
      Cambiar datos de notificación
    </button>
    <modal
      v-if="isModalOpen"
      id="notification-update-recurrence-modal"
      @closeModal="closeModal"
    >
      <p
        v-if="!pinSent"
        class="text-left"
      >
        ¿Desea enviar los datos vía sms y correo electrónico?
      </p>
      <p
        v-else
        class="text-left"
      >
        Se te ha enviado instrucciones a tu correo para hacer
        el cambio de datos de notificación.
      </p>

      <div class="w-100 flex justify-end m-t-8">
        <template v-if="!pinSent">
          <button
            class="bbutton cancel-button"
            @click="closeModal"
          >
            Cancelar
          </button>
          <button
            class="bbutton submit-button"
            :disabled="isLoading"
            @click="changePaymentMethod"
          >
            Aceptar
          </button>
        </template>
        <template v-else>
          <button
            class="bbutton cancel-button"
            @click="closeModal"
          >
            {{ $t('text.goBack') }}
          </button>
        </template>
      </div>
    </modal>
  </div>
</template>

<script>
import { Modal } from '@/components/ui';

export default {
  name: 'NotificationDataUpdateDialog',
  components: { Modal },
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      pinSent: false,
      isLoading: false,
      isModalOpen: false
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    changeNotificationData() {
      this.isLoading = true;
      global.api
        .mcwDdataNotificationIframeUpdate(this.service.serviceId, this.service.lineOfBusiness)
        .then(() => {
          this.isLoading = false;
          this.pinSent = true;
        }).catch((err) => {
          if (err.response.status === 400) {
            this.$router.push({ name: 'NoInvoicesRecurrence' });
          } else if (err.response.status === 429) {
            this.isError = 'El pin ya se había enviado';
            this.$router.push({ name: 'PinPaymentMethod' });
          } else if (err.response.status === 423) {
            this.isError = 'Haz llegado al límite de envío de PINS, favor de intentar más tarde.';
          } else {
            this.$router.push({ name: 'ErrorRecurrenceInvoices', query: { error: 'GENERIC_ERROR' } });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '@/assets/css/DialogButtons.scss';
</style>

